'use client';

import { useRouter } from 'next/navigation';

import { FormattedMessage } from '@flipster/i18n';
import { createTabsComponent } from '@flipster/react/design-system/tabs';

const Tabs = createTabsComponent<'contract' | 'leverage-margin'>();

interface Props {
  tab: 'contract' | 'leverage-margin';
  symbol: string;
}

const ContractTabs = ({ tab, symbol }: Props) => {
  const router = useRouter();

  const handleChangeTab = (tab: 'contract' | 'leverage-margin') => {
    router.replace(`../${tab}/${symbol}`);
  };

  return (
    <Tabs type='responsive' value={tab} onClick={handleChangeTab} border>
      <Tabs.Tab label={<FormattedMessage id='Trade.r251212.Contract' />} value='contract' />
      <Tabs.Tab label={<FormattedMessage id='Trade.r251212.Leverage_margin' />} value='leverage-margin' />
    </Tabs>
  );
};

export default ContractTabs;
